import { render } from "./incomeReport.vue?vue&type=template&id=2c39d3dd&scoped=true"
import script from "./incomeReport.vue?vue&type=script&lang=js"
export * from "./incomeReport.vue?vue&type=script&lang=js"

import "./incomeReport.vue?vue&type=style&index=0&id=2c39d3dd&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c39d3dd"]])

export default __exports__